import { parseSvgString } from '../domHelpers/svg';

const createCrossingMarker = () => {
  const icon = `
    <svg width="12px" height="12px" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6" cy="6" r="6" fill="#237274" />
    </svg>
  `;
  return parseSvgString(icon);
};

export default createCrossingMarker;
